<div *ngIf="filePath">
    <iframe title="Document" [src]="filePath | safe" width="100%" autosize style="height: calc(100vh);">
    </iframe>
</div>
<div *ngIf="!filePath" style="border: 1px solid;height: calc(100vh);">
    Preview unavailable for this document.
</div>